import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OfferStatusService } from '../../offer/services/offer-status.service';

@Pipe({
  name: 'offerStatus'
})
export class OfferStatusPipe implements PipeTransform {

  constructor(private _offerStatusService: OfferStatusService){ }

  transform(value: number): Observable<string> {
    return this._offerStatusService.getOfferStatusById(value, true).pipe(map(x => x? x.offerstatename: null));
  }

}
